export class APIError extends Error { constructor(public status:number, message:string){ super(message); } }

export const API_BASE=(import.meta.env.VITE_API_BASE_URL || "/api/v1").replace(/\/$/,"");
export const apiUrl=(path:string)=>`${API_BASE}${path}`;

export async function api<T=unknown>(path:string, init:RequestInit={}):Promise<T>{
  const headers=new Headers(init.headers||{});
  if(!(init.body instanceof FormData)&&!headers.has("Content-Type"))headers.set("Content-Type","application/json");
  const response=await fetch(apiUrl(path),{credentials:"include",...init,headers});
  if(!response.ok){let message="Request failed";try{message=(await response.json()).error||message}catch{}throw new APIError(response.status,message)}
  if(response.status===204)return undefined as T;
  return response.json() as Promise<T>;
}
